<label for="toggle-switch" class="toggle-switch-label">{{label}}</label>
<div class="toggle-bar" tabindex="0" (keydown.space)="toggle()" (keyup.enter)="toggle()" [attr.aria-label]="getAriaLabelForToggle()">
  <div class="toggle-switch" [class.checked]="isChecked" [class.disabled]="isDisabled" id="toggle-switch"
    (click)="toggle()" role="button" [attr.aria-checked]="isChecked" [attr.aria-disabled]="isDisabled">
    <div class="toggle-track"></div>
    <div class="toggle-slide"></div>
  </div>
</div>